import { createBrowserRouter, RouterProvider as ReactRouterProvider } from 'react-router-dom';

import { RouteErrorBoundary } from '@components/route-error-boundary';
import { useGoogleAnalytics } from '@hooks/use-google-analytics';

import { useCurrentUserQuery } from 'api/authentication/hooks';

import { AuthenticatedNavigation } from './authenticated/navigation';
import { PreboardingCompanyNavigation } from './preboarding-company/navigation';
import { PreboardingUserNavigation } from './preboarding-user/navigation';
import { UnauthenticatedNavigation } from './unauthenticated/navigation';

const Root = () => {
  const currentUser = useCurrentUserQuery();
  useGoogleAnalytics();

  if (currentUser.isLoading) {
    return null;
  }

  const Navigation = currentUser.data
    ? currentUser.data.company.hasFinishedPreboarding
      ? currentUser.data.hasFinishedPreboarding
        ? AuthenticatedNavigation
        : PreboardingUserNavigation
      : PreboardingCompanyNavigation
    : UnauthenticatedNavigation;

  return <Navigation />;
};

const router = createBrowserRouter([
  {
    path: '*',
    element: <Root />,
    errorElement: <RouteErrorBoundary />,
  },
]);

export const isInTemplateRoute = () => {
  return router.state.location.pathname.startsWith('/templates/');
};

export const RouterProvider = () => <ReactRouterProvider router={router} />;
